/* SA1 Digital Theme — theme.js */

// Sticky header
window.addEventListener('scroll', function () {
  var header = document.getElementById('site-header');
  if (header) {
    if (window.scrollY > 10) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }
});

// Search toggle
function toggleSearch() {
  var bar = document.getElementById('search-bar');
  if (!bar) return;
  if (bar.style.display === 'none' || bar.style.display === '') {
    bar.style.display = 'block';
    bar.querySelector('input').focus();
  } else {
    bar.style.display = 'none';
  }
}

// Mobile menu
function toggleMobileMenu() {
  var nav = document.getElementById('mobile-nav');
  if (!nav) return;
  nav.style.display = (nav.style.display === 'flex') ? 'none' : 'flex';
}

// Add to cart (AJAX)
function addToCart(variantId, btn) {
  if (!variantId) return;
  if (btn) {
    btn.classList.add('loading');
    btn.textContent = 'جاري الإضافة...';
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function (res) { return res.json(); })
  .then(function () {
    updateCartCount();
    if (btn) {
      btn.classList.remove('loading');
      btn.classList.add('added');
      btn.textContent = '✓ تمت الإضافة';
      setTimeout(function () {
        btn.classList.remove('added');
        btn.textContent = 'أضف للسلة';
      }, 2000);
    }
  })
  .catch(function () {
    if (btn) {
      btn.classList.remove('loading');
      btn.textContent = 'أضف للسلة';
    }
  });
}

// Update cart count in header
function updateCartCount() {
  fetch('/cart.js')
  .then(function (res) { return res.json(); })
  .then(function (cart) {
    var el = document.getElementById('cart-count');
    if (el) el.textContent = cart.item_count;
  });
}

// Category filter (homepage)
function filterCat(tag, btn) {
  // Update pills
  document.querySelectorAll('.cat-pill').forEach(function (p) {
    p.classList.remove('active');
  });
  if (btn) btn.classList.add('active');

  // Filter cards
  var cards = document.querySelectorAll('.product-card');
  cards.forEach(function (card) {
    if (tag === 'all') {
      card.style.display = '';
    } else {
      var tags = (card.dataset.tags || '').toLowerCase();
      card.style.display = tags.includes(tag) ? '' : 'none';
    }
  });
}

// Init
document.addEventListener('DOMContentLoaded', function () {
  updateCartCount();
});
